module.exports = __webpack_public_path__ + "static/img/3areaB_5.07f7afd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_5.png
// module id = 1168
// module chunks = 1